<script lang="ts">
  import { PageLoadingSpinner } from "$lib/ui/loading-spinner";
  import PageAccessDenied from "../PageAccessDenied.svelte";
  import { authStateStore } from "$lib/stores/user";
  import { selectedOrgStore } from "$lib/stores/orgs";
  import SectionTitle from "$lib/components/shared/SectionTitle.svelte";
  import CustomInfoTypesManager from "$lib/components/security/CustomInfoTypesManager.svelte";

  let isLoadingPage = $state(true);
  let canView = $derived.by(() => {
    const userEmail = $authStateStore.userInfo?.email?.toLowerCase();
    return (
      !!userEmail &&
      !!$selectedOrgStore?.members &&
      !!$selectedOrgStore?.members.find(
        (o) =>
          o.email?.toLowerCase() === userEmail && (o.claims.includes("org:write") || o.claims.includes("org:read")),
      )
    );
  });

  $effect(() => {
    if ($selectedOrgStore) {
      isLoadingPage = false;
    }
  });
</script>

{#if isLoadingPage}
  <PageLoadingSpinner timeout={10_000} message={"Loading..."} />
{:else if canView}
  <div class="grow px-6 lg:px-10 py-5 sm:py-8 lg:py-10 text-offblack">
    <SectionTitle>Custom Sensitive Data Types</SectionTitle>
    <div class="rounded-lg bg-white dark:bg-gray-900 shadow p-6">
      <CustomInfoTypesManager />
    </div>
  </div>
{:else}
  <PageAccessDenied />
{/if}
